import React from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';

const ErrorMessage = ({ message, title = 'Error', onRetry, className = '' }) => {
  return (
    <Alert severity="error" className={className} sx={{ borderRadius: 2 }}>
      {title && <AlertTitle>{title}</AlertTitle>}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
        <span>{message}</span>
        {onRetry && (
          <Button variant="outlined" color="error" size="small" onClick={onRetry}>
            Try Again
          </Button>
        )}
      </Box>
    </Alert>
  );
};

export default ErrorMessage;
